/**
 * Extracts initials from a Vietnamese region name.
 * E.g. "Hà Nội" → "HN", "Thành phố Hồ Chí Minh" → "TPHCM"
 */
export const getInitials = (name: string): string =>
  name
    .trim()
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase())
    .join("");
